import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SelectedPlan {
  name: string;
  content: string;
  duration: string;
  level: string;
  price: string;
}

interface SelectedCourse {
  id: number;
  title: string;
  selectedPlan: SelectedPlan | null;
}

interface CourseSelectionContextType {
  selectedCourse: SelectedCourse | null;
  setSelectedCourse: (course: SelectedCourse | null) => void;
}

const CourseSelectionContext = createContext<CourseSelectionContextType | undefined>(undefined);

export const useCourseSelection = () => {
  const context = useContext(CourseSelectionContext);
  if (context === undefined) {
    throw new Error('useCourseSelection must be used within a CourseSelectionProvider');
  }
  return context;
};

interface CourseSelectionProviderProps {
  children: ReactNode;
}

export const CourseSelectionProvider: React.FC<CourseSelectionProviderProps> = ({ children }) => {
  const [selectedCourse, setSelectedCourse] = useState<SelectedCourse | null>(null);

  return (
    <CourseSelectionContext.Provider value={{ selectedCourse, setSelectedCourse }}>
      {children}
    </CourseSelectionContext.Provider>
  );
};
